import { axios } from "../../config/axios";
const baseUrl = '/api/v3/users'

export const textMarketingAPI = {
  GETTextMarketing() {
    return axios.get(`${baseUrl}/should_show_text_marketing_warning`).then((resp) => {
        return resp.data
    });
  },
  PATCHTextMarketing(payload) {
    return axios.patch(`${baseUrl}/update_text_marketing_warning_flags`, payload);
  }
}
